// Shared control styles for the member import page and its CRM / timed-opening panels.
const ACTION =
  'relative inline-flex min-h-11 items-center justify-center gap-1 px-4 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50';
export const PRIMARY = `${ACTION} bg-primary text-primary-content hover:bg-primary/90`;
export const OUTLINE = `${ACTION} border border-base-300 text-base-content hover:bg-base-300`;
export const FIELD =
  'h-11 w-full border border-base-300 bg-base-100 px-3 text-base text-base-content';
export const DROPZONE =
  'relative flex min-h-32 cursor-pointer flex-col items-center justify-center gap-1 border-2 border-dashed p-8 text-center transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';
export const CHECK_LABEL = 'flex min-h-11 items-center gap-2 text-sm text-base-content';
export const CHECKBOX = 'h-5 w-5 shrink-0';
export const ALERT = 'border border-error p-3 text-sm text-error';
export const NOTE = 'border border-info bg-info/10 p-3 text-sm text-base-content';
